import {useMutation, UseMutationOptions} from "@tanstack/react-query";
import {AxiosError, AxiosResponse} from "axios";
import {UserResponse} from "../../../models/Interface/User.interface";
import {useNavigate} from "react-router-dom";
import axiosInstance, {CustomAxiosError} from "../../../utils/axios";
import {MutationKeys} from "../../mutation/mutation.enum";

interface IDeleteMainUser {
    mainUserId:string
}
type IDeleteUser = UseMutationOptions<AxiosResponse<UserResponse>, AxiosError, IDeleteMainUser>



const useDeleteMainUser = (options?: IDeleteUser) => {
    const navigation = useNavigate()
    const mutation =  useMutation({
        ...options,
        mutationFn: (data: {
            mainUserId:string
        }) => {
            return axiosInstance.delete(`/users/main/${data.mainUserId}`)
        },
        mutationKey:[MutationKeys.DELETE_MAIN_USER],
        onSuccess: (res, res1, res2) => {
            options?.onSuccess?.(res, res1, res2)

        },
        onError: (error: CustomAxiosError, variables, context) => {
            alert(error?.response?.data?.message )
            options?.onError?.(error, variables, context)
        },
    })


    return {
        mutateDeleteMainUser:mutation.mutate,
        ...mutation,
    }
}
export default useDeleteMainUser